import React, { useMemo } from 'react';
import _ from 'lodash';
import { withLocalize } from 'react-localize-redux';
import { useLocalize } from '../../hooks';
const externalLinkTextId = 'externalLink';
const ExternalLinkContent = ({ href, className, onClick, translate, children }) => {
    const { getTranslationId } = useLocalize();
    const ariaLabel = useMemo(() => {
        const val = translate(getTranslationId({ id: externalLinkTextId }));
        return _.isString(val) ? val : _.startCase(externalLinkTextId);
    }, [translate, getTranslationId]);
    return (React.createElement("a", { href: href, className: className, target: "_blank", rel: "noopener noreferrer", "aria-label": `(${ariaLabel})`, onClick: onClick }, children));
};
export const ExternalLink = withLocalize(ExternalLinkContent);
//# sourceMappingURL=ExternalLink.js.map